import React, { useState } from 'react';
import styles from './CnpPage.module.scss';
import { Input } from '../../../../ui/components/Input';
import { Button } from '../../../../ui/components/Button';
import { Checkbox } from '@/ui/components/Checkbox';
import { ArrowRightIcon, Icon } from '../../../../ui/icons/Icon';
import { idCard } from '@/assets/images/emojis';
import { routes } from '@/routes/routes';
import { Link, useNavigate } from 'react-router-dom';
import { useError } from '@/providers/Error';
import { CNP_LENGTH, useSubmitCnp } from '../../hooks/useSubmitCnp';

function CnpPage() {
  const { error } = useError();
  const [cnpValue, setCnpValue] = useState('');
  const navigate = useNavigate();

  // BC consent is asked here: the BC score comes before KYC.
  const [isBcConsentChecked, setIsBcConsentChecked] = useState(false);
  const { submitCnp, isLoading, cnpInUseModal } = useSubmitCnp({
    acceptsBcConsent: true,
  });

  const handleCnpChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCnpValue(value);
  };

  const handleContinue = async () => {
    if (await submitCnp(cnpValue)) {
      navigate(routes.onboarding.base);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (!isBcConsentChecked) {
        return;
      }
      handleContinue();
    }
  };

  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          <img src={idCard} alt="ID card emoji" className={styles.emoji} />
          <h1 className={styles.title}>Introdu CNP-ul tău</h1>
          <p className={styles.description}>
            În calitate de serviciu reglementat, avem nevoie să-ți verificăm
            identitatea, rapid și în siguranță
          </p>
        </div>

        <div className={styles.inputSection}>
          <Input
            label="CNP"
            autoFocus
            inputMode="numeric"
            autoComplete="off"
            maxLength={CNP_LENGTH}
            value={cnpValue}
            onChange={handleCnpChange}
            placeholder="1234567890123"
            error={!!error}
            className={styles.cnpInput}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className={styles.disclaimer}>
          <Icon name="shield-check" className={styles.infoIcon} />
          <p className={styles.disclaimerText}>
            Datele tale personale sunt în siguranță
          </p>
        </div>
      </div>

      <div className={styles.bottomSection}>
        <div className={styles.consent}>
          <Checkbox
            checked={isBcConsentChecked}
            onChange={(e) => setIsBcConsentChecked(e.target.checked)}
          />
          <p
            className={styles.consentLabel}
            onClick={() => setIsBcConsentChecked(!isBcConsentChecked)}
          >
            Sunt de acord cu interogarea la{' '}
            <Link
              to={routes.terms.bc}
              className={styles.consentLink}
              onClick={(e) => e.stopPropagation()}
            >
              Biroul de credit
            </Link>
          </p>
        </div>
        <Button
          trackingId="submit_cnp"
          text="Continuă"
          rightIcon={<ArrowRightIcon className={styles.arrowIcon} />}
          onClick={handleContinue}
          loading={isLoading}
          disabled={!isBcConsentChecked}
          className={styles.continueButton}
        />
      </div>

      {cnpInUseModal}
    </div>
  );
}

export default CnpPage;
